(() => {
  if (window.kareCartReady) return;
  window.kareCartReady = true;
  let busy = false;
  function enhance(scope = document) {scope.querySelectorAll('[data-kc-step]').forEach(b => b.hidden = false);}
  function showError(root, message, reload = false) {
    const box = root.querySelector('[data-kc-error]'); box.replaceChildren(document.createTextNode(message)); box.hidden = false;
    if (reload) { const a = document.createElement('a'); a.href = root.dataset.cartUrl; a.textContent = ' Reload cart'; box.append(a); }
    box.tabIndex = -1; box.focus();
  }
  function lock(root, value) {
    busy = value; root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button,input,textarea').forEach(el => el.disabled = value);
    root.querySelectorAll('[data-kc-remove]').forEach(el => el.setAttribute('aria-disabled', String(value)));
  }
  async function change(root, line, quantity) {
    if (busy || root.dataset.stale) return;
    const input = line.querySelector('[data-kc-quantity]');
    const note = root.querySelector('[data-kc-note]')?.value || '';
    const noteOpen = root.querySelector('.kc-note')?.open;
    const key = line.dataset.key;
    const openKeys = Array.from(root.querySelectorAll('[data-kc-line]')).filter(el => el.querySelector('details')?.open).map(el => el.dataset.key);
    root.querySelector('[data-kc-error]').hidden = true;
    lock(root, true);root.querySelector('[data-kc-status]').textContent = 'Updating your cart…';
    let changed = false;
    try {
      const url = root.dataset.cartUrl;
      const response = await fetch(url + '/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
      const cart = await response.json();
      if (!response.ok) {const error=new Error(typeof cart.description === 'string' ? cart.description : 'This quantity is not available. Please choose another amount.');error.kcRejected=true;throw error;}
      changed = true;
      const htmlResponse = await fetch(url + '?view=kare-cart', {cache:'no-store',headers:{'Accept':'text/html'}});
      if (!htmlResponse.ok) throw new Error('refresh');
      const doc = new DOMParser().parseFromString(await htmlResponse.text(), 'text/html');
      const fresh = doc.querySelector('[data-kare-cart]');
      if (!fresh) throw new Error('refresh');
      if (fresh.querySelector('[data-kc-note]')) {fresh.querySelector('[data-kc-note]').value = note;fresh.querySelector('.kc-note').open = noteOpen;}
      fresh.querySelectorAll('[data-kc-line]').forEach(el => {if(openKeys.includes(el.dataset.key) && el.querySelector('details')) el.querySelector('details').open=true;});
      root.replaceWith(fresh);enhance(fresh);busy=false;
      fresh.querySelector('[data-kc-status]').textContent = quantity === 0 ? 'Item removed.' : 'Cart updated.';
      const target = Array.from(fresh.querySelectorAll('[data-kc-line]')).find(el => el.dataset.key === key)?.querySelector('[data-kc-quantity]') || fresh.querySelector('[data-kc-checkout]') || fresh.querySelector('a');
      target?.focus({preventScroll:true});
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      document.querySelectorAll('.bag__item-alert').forEach(el => el.classList.toggle('is-visible',cart.item_count > 0));
      document.dispatchEvent(new CustomEvent('kare:cart-updated',{detail:{cart}}));
    } catch (error) {
      lock(root,false);root.querySelector('[data-kc-status]').textContent='';input.value=input.dataset.savedQuantity;
      if (changed || !error.kcRejected) {root.dataset.stale='true';root.querySelectorAll('button,input,textarea').forEach(el=>el.disabled=true);showError(root,changed ? 'Your cart changed, but the updated summary could not load. Reload before continuing.' : 'We could not confirm the latest cart. Reload before continuing.',true);}
      else showError(root,error instanceof TypeError ? 'We could not connect. Reload your cart to check the quantity before trying again.' : error.message);
    }
  }
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-kare-cart]');if (!root) return;
    const step = event.target.closest('[data-kc-step]'), remove = event.target.closest('[data-kc-remove]');
    if (!step && !remove) return;event.preventDefault();if(busy || root.dataset.stale)return;
    const line = event.target.closest('[data-kc-line]'), input = line.querySelector('[data-kc-quantity]');
    if(remove){change(root,line,0);return;}
    const min=Number(input.min)||1,increment=Number(input.step)||1,max=input.max ? Number(input.max) : Infinity;
    const next=Number(input.value)+Number(step.dataset.kcStep)*increment;
    if(next<min || next>max)return;
    input.value=String(next);change(root,line,next);
  });
  document.addEventListener('change', event => {
    const input=event.target.closest('[data-kc-quantity]');if(!input)return;
    const root=input.closest('[data-kare-cart]');
    if(!input.checkValidity() || !Number.isInteger(Number(input.value))){input.reportValidity();input.value=input.dataset.savedQuantity;return;}
    if(input.value!==input.dataset.savedQuantity)change(root,input.closest('[data-kc-line]'),Number(input.value));
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-kc-form]');if(!form)return;
    if(busy || form.closest('[data-kare-cart]').dataset.stale){event.preventDefault();return;}
    // Native Shopify cart POST saves the current note (including a cleared note)
    // and quantities before the checkout or update action. No note-saving timer.
  });
  function setupDrawer() {
    const drawer=document.querySelector('.kc-drawer');if(!drawer)return;
    let previousFocus=null,wasOpen=false;
    function close(){drawer.classList.remove('is-visible');document.body.classList.remove('no-scroll');}
    function sync(){
      const open=drawer.classList.contains('is-visible');drawer.inert=!open;drawer.setAttribute('aria-hidden',String(!open));
      if(open&&!wasOpen){previousFocus=document.activeElement;drawer.querySelector('[data-toggle-bag]')?.focus();}
      if(!open&&wasOpen&&previousFocus?.isConnected)previousFocus.focus();
      wasOpen=open;enhance(drawer);
    }
    new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});
    new MutationObserver(()=>enhance(drawer)).observe(drawer.querySelector('[data-mini-cart-items]'),{childList:true});
    document.querySelector('.mini-cart__backdrop')?.addEventListener('click',close);
    drawer.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();close();}
      if(event.key==='Tab'){
        const nodes=Array.from(drawer.querySelectorAll('a,button,input,textarea,summary,[tabindex="0"]')).filter(el=>!el.disabled&&el.getClientRects().length);
        const first=nodes[0],last=nodes[nodes.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{enhance();setupDrawer();});else{enhance();setupDrawer();}
})();
